<template>
  <div class="card-list" :style="cssVariables">
    <div class="card-list__filters">
      <slot name="filters" />
    </div>
    <transition name="empty" mode="out-in">
      <transition-group v-if="!isEmpty" class="card-list__items" name="card-filter" tag="div" @before-leave="transitionItemBeforeLeave" mode="out-in" appear>
        <!-- <div class="card-list__item" v-for="item in items.slice(0, maxItems)" :key="item[idKey]">
          <slot name="card" :item="item" />
        </div> -->
        <div class="card-list__item" v-for="item in items" :key="item[idKey]">
          <slot name="card" :item="item" />
        </div>
      </transition-group>
      <div v-else class="card-list__empty">
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
          class="card-list__empty__icon"
          height="512" viewBox="0 0 1024 1024">
          <path
            d="M513.194667 806.4c-31.943111 0-57.514667 24.803556-57.514667 56.803556v0.796444c0 6.4 4.778667 11.207111 11.178667 11.207111s11.178667-4.807111 11.178666-11.207111v-0.796444c0-18.375111 15.189333-34.389333 34.360889-34.389334 19.171556 0 34.360889 16.014222 34.360889 34.389334v0.796444c0 6.4 4.807111 11.207111 11.207111 11.207111s11.178667-4.807111 11.178667-11.207111v-0.796444c1.564444-30.407111-24.803556-56.803556-55.950222-56.803556z m131.811555-88.803556c-23.153778 4.807111-55.921778 32.796444-51.911111 58.424889 2.389333 10.382222 11.975111 16.782222 31.146667 13.596445 35.157333-5.575111 50.346667-1.592889 59.932444-4.778667 9.557333-3.214222 11.975111-18.403556-3.214222-24.007111-15.957333-5.603556-33.564444 1.592889-37.546667-2.417778-2.389333-3.185778 4.835556-9.585778 17.607111-12.003555 15.160889-3.185778 31.943111-4.807111 28.757334-15.189334-4.835556-16.839111-27.989333-17.635556-44.771556-13.624889z m-265.216 0c-15.985778-3.185778-39.139556-3.185778-44.743111 13.624889-3.185778 10.382222 13.568 11.207111 28.757333 15.189334 11.975111 3.185778 18.375111 9.614222 17.578667 11.207111-3.214222 4.010667-21.560889-3.185778-37.546667 2.417778-15.985778 5.575111-12.771556 19.996444-3.185777 24.007111 9.585778 3.185778 24.775111-0.796444 59.904 4.807111 17.578667 3.185778 28.757333-3.214222 31.146666-13.624889 3.214222-24.832-29.553778-52.849778-51.911111-57.628445z m635.107556-234.410666l-199.708445-184.007111a26.453333 26.453333 0 0 0-16.782222-5.603556H226.389333a25.770667 25.770667 0 0 0-16.782222 6.428445L8.305778 484.010667a26.083556 26.083556 0 0 0-7.992889 18.375111v450.417778A71.310222 71.310222 0 0 0 71.424 1024v-0.796444h881.123556c39.168 0 71.111111-32 71.111111-71.196445V501.589333c0-6.4-3.982222-13.596444-8.760889-18.403555zM229.603556 324.010667h567.182222l173.368889 160H663.381333c-6.4 0-12.003556 5.575111-12.003555 12.8 0 73.585778-63.118222 135.964444-137.386667 135.964444-74.296889 0-137.415111-62.378667-137.415111-135.964444 0-6.428444-5.603556-12.8-11.975111-12.8H54.641778l174.961778-160z m762.908444 628.792889c0 22.385778-17.550222 39.196444-39.139556 39.196444H72.248889c-22.385778 0-40.760889-17.607111-40.760889-39.196444V509.582222h320.341333l1.592889 9.614222c5.603556 36.010667 22.385778 68.807111 48.725334 92.814223a162.360889 162.360889 0 0 0 111.843555 44.8c41.557333 0 80.668444-16.014222 111.843556-44.8 26.368-26.424889 43.150222-58.424889 48.725333-92.814223l1.621333-9.614222h316.330667v443.221334z m-254.833778-729.6c19.171556 0 35.157333-16.014222 35.157334-35.214223s-16.014222-35.185778-35.157334-35.185777-35.128889 16.014222-35.128889 35.185777a35.470222 35.470222 0 0 0 35.128889 35.214223z m0-53.617778c10.382222 0 19.171556 8.817778 19.171556 19.2 0 10.410667-8.789333 19.2-19.171556 19.2s-19.171556-8.789333-19.171555-19.2c0-10.410667 8.760889-19.2 19.171555-19.2zM184.860444 105.585778c28.757333 0 52.736-24.007111 52.736-52.792889S213.617778-0.028444 184.860444-0.028444c-28.757333 0-52.736 24.007111-52.736 52.792888s23.978667 52.821333 52.736 52.821334z m0-89.571556c19.968 0 36.750222 16.782222 36.750223 36.778667S204.828444 89.6 184.860444 89.6s-36.750222-16.810667-36.750222-36.835556S164.892444 16.014222 184.860444 16.014222z m160.568889 144.753778h10.382223v10.410667c0 4.807111 3.185778 7.992889 7.992888 7.992889a7.992889 7.992889 0 0 0 7.992889-7.992889v-10.410667h9.585778c4.778667 0 7.992889-3.185778 7.992889-7.992889 0-4.778667-3.185778-7.992889-7.992889-7.992889h-9.585778v-9.585778c0-4.807111-3.214222-7.992889-7.992889-7.992888s-7.992889 3.185778-7.992888 7.992888v9.585778h-10.382223c-4.778667 0-7.992889 3.214222-7.992889 7.992889 0 4.807111 3.214222 7.992889 7.992889 7.992889zM37.091556 266.382222h27.164444v27.192889c0 4.807111 3.185778 7.992889 7.992889 7.992889 4.778667 0 7.964444-3.185778 7.964444-7.992889v-27.192889h27.164445c4.807111 0 7.992889-3.185778 7.992889-7.992889s-3.185778-7.992889-7.992889-7.992889H80.213333v-27.192888c0-4.807111-3.185778-7.992889-7.964444-7.992889-4.807111 0-7.992889 3.185778-7.992889 7.992889v27.192888h-27.164444c-4.778667 0-7.992889 3.185778-7.992889 7.992889s3.185778 7.992889 7.992889 7.992889z m880.327111 16.014222h17.578666v17.607112c0 4.778667 3.157333 7.992889 7.992889 7.992888 4.778667 0 7.964444-3.214222 7.964445-7.992888v-17.607112h17.578666c4.778667 0 7.964444-3.185778 7.964445-7.992888s-3.185778-7.992889-7.964445-7.992889h-17.578666v-17.635556c0-4.778667-3.185778-7.992889-7.964445-7.992889-4.835556 0-7.992889 3.214222-7.992889 7.992889v17.607111h-17.578666c-4.807111 0-7.964444 3.185778-7.964445 7.992889s3.157333 8.021333 7.964445 8.021333z m-102.257778-152.803555h31.943111v32c0 4.807111 3.214222 7.992889 7.992889 7.992889s7.992889-3.185778 7.992889-7.992889V129.592889h31.943111c4.778667 0 7.992889-3.185778 7.992889-7.992889s-3.214222-7.992889-7.992889-7.992889h-31.943111V80.782222c0-4.778667-3.214222-7.992889-7.992889-7.992889s-7.992889 3.214222-7.992889 7.992889v32.796445h-31.943111c-4.778667 0-7.992889 3.185778-7.992889 7.992889s3.214222 8.021333 7.992889 8.021333z"
            :fill="buttonColor" />
        </svg>
      </div>
    </transition>
    <!-- <div v-if="maxItems < items.length">
      <a class="card-list__loadmore-button" @click="loaded += columns * 2">Load More</a>
    </div> -->
  </div>
</template>

<script>
export default {

  name: 'card-list',

  props: {
    textColor: {
      type: String,
      default: '#ffffff'
    },
    accentColor: {
      type: String,
      default: '#ffffff'
    },
    buttonColor: {
      type: String,
      default: '#ffffff'
    },
    buttonTextColor: {
      type: String,
      default: '#ffffff'
    },
    columns: {
      type: Number,
      default: 2
    },
    items: {
      type: Array,
      default: () => []
    },
    idKey: {
      type: String,
      default: 'id'
    }
  },

  data () {
    return {
      loaded: 0
    }
  },

  computed: {

    cssVariables () {
      return {
        '--columns': this.columns,
        '--text-color': this.textColor,
        '--accent-color': this.accentColor,
        '--button-color': this.buttonColor,
        '--button-text-color': this.buttonTextColor
      }
    },

    /* maxItems () {
      return this.columns * 2 + this.loaded
    }, */

    isEmpty () {
      if (typeof this.items === 'undefined') {
        return false
      } else {
        return this.items.length < 1
      }
    }
  },

  methods: {
    transitionItemBeforeLeave (el) {
      el.style.left = `${el.offsetLeft}px`
      el.style.top = `${el.offsetTop}px`
      el.style.margin = 0
      el.style.maxWidth = `${el.getBoundingClientRect().width}px`
      el.style.height = `${el.getBoundingClientRect().height}px`
    }
  }
}
</script>

<style lang="scss" scoped>

.card-list {

  &__filters {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 1rem 0;

    @media (max-width: 1200px) {
      flex-direction: column;
      align-items: center;
    }
  }

  &__items {
    position: relative;
    padding: 1rem 0;
    backface-visibility: hidden;

    display: grid;
    grid-template-columns: repeat(var(--columns), 1fr);
    grid-auto-rows: minmax(min-content, max-content);
    -webkit-columns: var(--columns);
     -moz-columns: var(--columns);
          columns: var(--columns);
    -webkit-column-gap: 1rem;
      -moz-column-gap: 1rem;
           column-gap: 1rem;
    -webkit-row-gap: 1rem;
      -moz-row-gap: 1rem;
           row-gap: 1rem;

    transition: contents 1s ease-in-out;
    will-change: contents;
  }

  &__item {
    /* display: inline-flex;
    width: calc(100% / var(--columns) - 1rem * (var(--columns) - 1) / var(--columns));
    margin: 0.5rem 1rem 0.5rem 0; */
    display: flex;
    height: 100%;
    transform-origin: 10% 50%;
    backface-visibility: hidden;

    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  &__empty {
    display: flex;
    padding: 1rem 0;
    justify-content: center;
    transition: all 1s;
  }

  &__loadmore-button {
    background: none;
    border: 0;
    -webkit-appearance: none;
    color: var(--text-color) !important;
    background-color: var(--accent-color);
    width: 200px;
    margin: 2rem auto;
    display: block;
    padding: 1rem;
    cursor: pointer;
    transition: color .8s, background-color .8s;
    text-decoration: none;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.2rem;

    &:hover,
    &:focus,
    &:active,
    &:not(:disabled):not(.disabled):active,
    &:not(:disabled):not(.disabled).active {
      color: var(--accent-color) !important;
      background: var(--button-color);
      outline: none;
      -webkit-box-shadow: none;
      box-shadow: none;
    }
  }
}

/* Transitions */

.card-filter {

  &-item {
  }

  &-move {
    transition: transform 1s cubic-bezier(0.77, 0, 0.175, 1);
    @for $i from 1 through 100 {
      &:nth-child(#{$i}) {
        transition: transform .4s #{$i * 0.1}s cubic-bezier(0.77, 0, 0.175, 1);
      }
    }
  }

  &-enter-active {
    transition: all 1s;
  }

  &-leave-active {
    transition: all 1s ease;
    transform: translateY(10px);
    position: absolute;
    opacity: 0;
  }
}

.empty {
  &-enter-active, &-leave-active {
    transition: opacity .5s ease;
  }
  &-enter, &-leave-to {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CardList.vue